import React from "react";

const Reflections = () => <div />;
export default Reflections;
